import soundFileMP3 from './alert.mp3';

const commonSoundProps = {
  src: [soundFileMP3],
  autoplay: false,
  loop: false,
};

export default commonSoundProps;



// WEBPACK FOOTER //
// ../ui-components/components/OrderSoundPlayer/commonSoundProps.js